{
	"agents": [
		{
			"agentType": "mcp",
			"accountId": "712020:mock-agent-external",
			"displayName": "External session",
			"views": 110,
			"created": 5,
			"updated": 2,
			"commentCreated": 1,
			"searchPerformed": 0,
			"relatedUserAccountId": "712020:mock-human-alex",
			"relatedUserDisplayName": "Alex Rivera",
			"lastViewedAt": "2026-08-21T15:30:00.000Z"
		},
		{
			"agentType": "cursor",
			"accountId": "712020:mock-agent-cursor",
			"displayName": "Cursor session",
			"views": 104,
			"created": 4,
			"updated": 2,
			"commentCreated": 0,
			"searchPerformed": 1,
			"relatedUserAccountId": "712020:mock-human-alex",
			"relatedUserDisplayName": "Alex Rivera",
			"lastViewedAt": "2026-08-21T15:18:00.000Z"
		},
		{
			"agentType": "canva",
			"accountId": "712020:mock-agent-canva",
			"displayName": "Canva session",
			"views": 99,
			"created": 3,
			"updated": 1,
			"commentCreated": 1,
			"searchPerformed": 0,
			"relatedUserAccountId": "712020:mock-human-sam",
			"relatedUserDisplayName": "Sam Chen",
			"lastViewedAt": "2026-08-21T15:10:00.000Z"
		},
		{
			"agentType": "claude",
			"accountId": "712020:mock-agent-claude",
			"displayName": "Claude session",
			"views": 96,
			"created": 4,
			"updated": 2,
			"commentCreated": 1,
			"searchPerformed": 0,
			"relatedUserAccountId": "712020:mock-human-alex",
			"relatedUserDisplayName": "Alex Rivera",
			"lastViewedAt": "2026-08-21T15:04:00.000Z"
		},
		{
			"agentType": "codex",
			"accountId": "712020:mock-agent-codex",
			"displayName": "Codex session",
			"views": 88,
			"created": 3,
			"updated": 1,
			"commentCreated": 0,
			"searchPerformed": 0,
			"relatedUserAccountId": "712020:mock-human-alex",
			"relatedUserDisplayName": "Alex Rivera",
			"lastViewedAt": "2026-08-21T14:50:00.000Z"
		},
		{
			"agentType": "rovo_chat",
			"accountId": "712020:mock-agent-rovo",
			"displayName": "Rovo session",
			"views": 81,
			"created": 2,
			"updated": 2,
			"commentCreated": 0,
			"searchPerformed": 1,
			"relatedUserAccountId": "712020:mock-human-sam",
			"relatedUserDisplayName": "Sam Chen",
			"lastViewedAt": "2026-08-21T14:20:00.000Z"
		},
		{
			"agentType": "first_party",
			"accountId": "712020:mock-agent-first-party",
			"displayName": "1P session",
			"views": 80,
			"created": 2,
			"updated": 1,
			"commentCreated": 1,
			"searchPerformed": 0,
			"relatedUserAccountId": "712020:mock-human-alex",
			"relatedUserDisplayName": "Alex Rivera",
			"lastViewedAt": "2026-08-21T14:10:00.000Z"
		},
		{
			"agentType": "amplitude",
			"accountId": "712020:mock-agent-amplitude",
			"displayName": "Amplitude session",
			"views": 78,
			"created": 1,
			"updated": 2,
			"commentCreated": 0,
			"searchPerformed": 1,
			"relatedUserAccountId": "712020:mock-human-sam",
			"relatedUserDisplayName": "Sam Chen",
			"lastViewedAt": "2026-08-21T14:00:00.000Z"
		},
		{
			"agentType": "antigravity",
			"accountId": "712020:mock-agent-antigravity",
			"displayName": "Antigravity session",
			"views": 77,
			"created": 3,
			"updated": 1,
			"commentCreated": 0,
			"searchPerformed": 0,
			"relatedUserAccountId": "712020:mock-human-alex",
			"relatedUserDisplayName": "Alex Rivera",
			"lastViewedAt": "2026-08-21T13:50:00.000Z"
		},
		{
			"agentType": "chatgpt",
			"accountId": "712020:mock-agent-chatgpt",
			"displayName": "ChatGPT session",
			"views": 76,
			"created": 2,
			"updated": 1,
			"commentCreated": 1,
			"searchPerformed": 0,
			"relatedUserAccountId": "712020:mock-human-sam",
			"relatedUserDisplayName": "Sam Chen",
			"lastViewedAt": "2026-08-21T13:40:00.000Z"
		},
		{
			"agentType": "cortex",
			"accountId": "712020:mock-agent-cortex",
			"displayName": "Cortex session",
			"views": 75,
			"created": 1,
			"updated": 3,
			"commentCreated": 0,
			"searchPerformed": 1,
			"relatedUserAccountId": "712020:mock-human-alex",
			"relatedUserDisplayName": "Alex Rivera",
			"lastViewedAt": "2026-08-21T13:30:00.000Z"
		},
		{
			"agentType": "databricks",
			"accountId": "712020:mock-agent-databricks",
			"displayName": "Databricks session",
			"views": 74,
			"created": 2,
			"updated": 2,
			"commentCreated": 0,
			"searchPerformed": 0,
			"relatedUserAccountId": "712020:mock-human-sam",
			"relatedUserDisplayName": "Sam Chen",
			"lastViewedAt": "2026-08-21T13:20:00.000Z"
		},
		{
			"agentType": "dia",
			"accountId": "712020:mock-agent-dia",
			"displayName": "Dia session",
			"views": 73,
			"created": 1,
			"updated": 1,
			"commentCreated": 1,
			"searchPerformed": 0,
			"relatedUserAccountId": "712020:mock-human-alex",
			"relatedUserDisplayName": "Alex Rivera",
			"lastViewedAt": "2026-08-21T13:10:00.000Z"
		},
		{
			"agentType": "gemini",
			"accountId": "712020:mock-agent-gemini",
			"displayName": "Gemini session",
			"views": 72,
			"created": 3,
			"updated": 2,
			"commentCreated": 0,
			"searchPerformed": 1,
			"relatedUserAccountId": "712020:mock-human-sam",
			"relatedUserDisplayName": "Sam Chen",
			"lastViewedAt": "2026-08-21T13:00:00.000Z"
		},
		{
			"agentType": "github_copilot",
			"accountId": "712020:mock-agent-github-copilot",
			"displayName": "GitHub Copilot session",
			"views": 71,
			"created": 2,
			"updated": 1,
			"commentCreated": 0,
			"searchPerformed": 0,
			"relatedUserAccountId": "712020:mock-human-alex",
			"relatedUserDisplayName": "Alex Rivera",
			"lastViewedAt": "2026-08-21T12:50:00.000Z"
		},
		{
			"agentType": "grok",
			"accountId": "712020:mock-agent-grok",
			"displayName": "Grok session",
			"views": 70,
			"created": 1,
			"updated": 2,
			"commentCreated": 1,
			"searchPerformed": 0,
			"relatedUserAccountId": "712020:mock-human-sam",
			"relatedUserDisplayName": "Sam Chen",
			"lastViewedAt": "2026-08-21T12:40:00.000Z"
		},
		{
			"agentType": "hermes",
			"accountId": "712020:mock-agent-hermes",
			"displayName": "Hermes Agent session",
			"views": 69,
			"created": 2,
			"updated": 1,
			"commentCreated": 0,
			"searchPerformed": 1,
			"relatedUserAccountId": "712020:mock-human-alex",
			"relatedUserDisplayName": "Alex Rivera",
			"lastViewedAt": "2026-08-21T12:30:00.000Z"
		},
		{
			"agentType": "kiro",
			"accountId": "712020:mock-agent-kiro",
			"displayName": "Kiro session",
			"views": 68,
			"created": 3,
			"updated": 2,
			"commentCreated": 0,
			"searchPerformed": 0,
			"relatedUserAccountId": "712020:mock-human-sam",
			"relatedUserDisplayName": "Sam Chen",
			"lastViewedAt": "2026-08-21T12:20:00.000Z"
		},
		{
			"agentType": "manus",
			"accountId": "712020:mock-agent-manus",
			"displayName": "Manus session",
			"views": 67,
			"created": 1,
			"updated": 1,
			"commentCreated": 1,
			"searchPerformed": 0,
			"relatedUserAccountId": "712020:mock-human-alex",
			"relatedUserDisplayName": "Alex Rivera",
			"lastViewedAt": "2026-08-21T12:10:00.000Z"
		},
		{
			"agentType": "microsoft_copilot",
			"accountId": "712020:mock-agent-microsoft-copilot",
			"displayName": "Microsoft Copilot session",
			"views": 66,
			"created": 2,
			"updated": 3,
			"commentCreated": 0,
			"searchPerformed": 1,
			"relatedUserAccountId": "712020:mock-human-sam",
			"relatedUserDisplayName": "Sam Chen",
			"lastViewedAt": "2026-08-21T12:00:00.000Z"
		},
		{
			"agentType": "openai",
			"accountId": "712020:mock-agent-openai",
			"displayName": "OpenAI session",
			"views": 65,
			"created": 3,
			"updated": 1,
			"commentCreated": 0,
			"searchPerformed": 0,
			"relatedUserAccountId": "712020:mock-human-alex",
			"relatedUserDisplayName": "Alex Rivera",
			"lastViewedAt": "2026-08-21T11:50:00.000Z"
		},
		{
			"agentType": "slack",
			"accountId": "712020:mock-agent-slack",
			"displayName": "Slack session",
			"views": 64,
			"created": 1,
			"updated": 2,
			"commentCreated": 1,
			"searchPerformed": 0,
			"relatedUserAccountId": "712020:mock-human-sam",
			"relatedUserDisplayName": "Sam Chen",
			"lastViewedAt": "2026-08-21T11:40:00.000Z"
		},
		{
			"agentType": "vscode",
			"accountId": "712020:mock-agent-vscode",
			"displayName": "Visual Studio Code session",
			"views": 63,
			"created": 2,
			"updated": 1,
			"commentCreated": 0,
			"searchPerformed": 1,
			"relatedUserAccountId": "712020:mock-human-alex",
			"relatedUserDisplayName": "Alex Rivera",
			"lastViewedAt": "2026-08-21T11:30:00.000Z"
		}
	]
}
